import { all } from 'redux-saga/effects';
import { sLicense } from 'saga/sLicense';
import { sMessageBox } from 'saga/sMessageBox';
import { sAuth } from 'saga/sAuth';
import { sClient } from 'saga/sClient';
import { sProduct } from 'saga/sProduct';
import { sContract } from 'saga/sContract';
import { sValidation } from 'saga/sValidation';
import { sDownload } from 'saga/sDownload';
import { sSetting } from 'saga/sSetting';

// 모든 사가를 합쳐주는 rootSaga
export default function* rootSaga() {
	yield all([
		sLicense(),
		sMessageBox(),
		sAuth(),
		sClient(),
		sProduct(),
		sContract(),
		sValidation(),
		sDownload(),
		sSetting(),
	]);
}
